import { useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { calculateWordsFromString, getFullMonthSelected, getMonthName } from "../../../utils/Helper";
import { decryptData, encryptData } from "../../../utils/encrypt";

export const usePrecisionEntry = () => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [employeeDetails, setEmployeeDetails] = useState([])
    const [filterValue, setFilterValue] = useState({
        date: new Date((new Date()).setMonth((new Date()).getMonth() - 1))
    });
    const [userCode, setUserCode] = useState(null);
    const [expanded, setExpanded] = useState({});
    const [options, setOptions] = useState({});
    const [loader, setLoader] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [confirmationPopup, setConfirmationPopup] = useState({ show: false })

     useEffect(() => {
        callautopopulate("users", "user_info", "projects", "technology", "user_involvement_levels", "project_leads").then(async res => {
            setUserCode(res?.user_info[0]?.user_code)
            const data = _.filter(res?.project_leads, { user_code: res?.user_info[0]?.user_code })
            setOptions({
                users: _.sortBy(res?.users, "user_display_name"),
                projects: _.sortBy(res?.projects, "project_name"),
                technology: _.sortBy(res?.technology, "technology_name"),
                involvementLevels: _.sortBy(res?.user_involvement_levels, "involvement_level_name"),
                leadOption: _.sortBy(res?.project_leads, "user_display_name"),
            });
            setFilterValue((prev) => ({ ...prev, lead: data, isAPICall: true, }))

        });
    }, []);

    useEffect(() => {
        if (filterValue?.isAPICall && filterValue.apiCall) {
            getPrecisionDetails();
        }
    }, [filterValue?.isAPICall,filterValue.apiCall]);

    const getPrecisionDetails = async (date) => {
        try {
            setLoader(true)
            const selected_date = date ? getFullMonthSelected(date) : getFullMonthSelected(filterValue?.date);
            const payload = {
                "from_date": selected_date?.from_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                "to_date": selected_date?.to_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                "users": _.pluck(filterValue?.users, "user_code")?.toString(),
                "technologies": _.pluck(filterValue?.technology, "technology_name")?.toString(),
                "project_ids": _.pluck(filterValue?.projects, "project_id")?.toString(),
                "project_lead_user_code": _.pluck(filterValue?.project_leads, "user_code")?.toString(),
            }
            const res = await services?.getInvokeRemote("POST", Urls("GETTEAMOVERVIEWPRECISIONPULSEMETRICS"), payload);
            if (!res?.body?.data?.error_status && res?.body?.data?.current_month_precision_data?.length > 0) {
                const employeeMap = {};
                [...res?.body?.data?.previous_month_precision_data, ...res?.body?.data?.current_month_precision_data]?.forEach(emp => {
                    if (!employeeMap[emp.user_code]) {
                        employeeMap[emp.user_code] = {
                            id: emp.user_code,
                            name: emp.user_display_name,
                            swot: {
                                strength: "",
                                weakness: "",
                                opportunity: "",
                                threat: ""
                            },
                            category: {},
                            involvement: null,
                            is_submit: false,
                            is_save: emp?.is_save,
                            rank_trend: [],
                            projectsWiseRank: [],
                            chart: "overall_standing_rank",
                            remark: ""
                        };
                    }
                    if (emp.report_month !== selected_date?.from_date?.getMonth() + 1) {
                        employeeMap[emp.user_code].rank_trend.push({
                            overall_standing_rank: decryptData(emp.overall_standing_rank) || 0,
                            bu_rank: decryptData(emp.bu_rank) || 0,
                            db_eff_rank: decryptData(emp.db_eff_rank) || "",
                            tech_rank: decryptData(emp.tech_rank) || "0",
                            extra_efforts: decryptData(emp.extra_efforts) || "",
                            time_efficiency_rank: decryptData(emp.time_efficiency_rank) || "0",
                            involvement_level_id: decryptData(emp.involvement_level_id) || 0,
                            year: emp?.report_year,
                            month: emp.report_month,
                            project_id: emp?.project_id,
                            projectName: emp?.project_name
                        });

                        employeeMap[emp.user_code].rank_trend = employeeMap[emp.user_code].rank_trend.sort(
                            (a, b) => a.year - b.year || a.month - b.month
                        );
                    }
                    if (emp.report_month === selected_date?.from_date?.getMonth()) {
                        if (!employeeMap[emp.user_code].prevProjectsWiseRank) {
                            employeeMap[emp.user_code].prevProjectsWiseRank = [];
                        }
                        employeeMap[emp.user_code].prevProjectsWiseRank.push({
                            project_id: emp.project_id || 0,
                            projectName: emp.project_name || "Overall",
                            bu_rank: decryptData(emp.bu_rank) || "0",
                            db_eff_rank: decryptData(emp.db_eff_rank) || "",
                            tech_rank: decryptData(emp.tech_rank) || "0",
                            extra_efforts: decryptData(emp.extra_efforts) || "",
                            time_efficiency_rank: decryptData(emp.time_efficiency_rank) || "0",
                            overall_standing_rank: decryptData(emp.overall_standing_rank) || "0",
                            involvement_level_id: emp?.involvement_level_id || "0"
                        });
                    }
                    if (emp.report_month === selected_date?.from_date?.getMonth() + 1) {
                        employeeMap[emp.user_code].swot = {
                            strength: emp.strength ? decryptData(emp.strength) : "",
                            weakness: emp.weakness ? decryptData(emp.weakness) : "",
                            opportunity: emp.opportunity ? decryptData(emp.opportunity) : "",
                            threat: emp.threat ? decryptData(emp.threat) : "",
                        };
                        if (!employeeMap[emp.user_code].projectsWiseRank) {
                            employeeMap[emp.user_code].projectsWiseRank = [];
                        }
                        employeeMap[emp.user_code].projectsWiseRank.push({
                            project_id: emp.project_id || 0,
                            projectName: emp.project_name || "Overall",
                            bu_rank: decryptData(emp.bu_rank) || "0",
                            db_eff_rank: decryptData(emp.db_eff_rank) || "",
                            tech_rank: decryptData(emp.tech_rank) || "0",
                            extra_efforts: decryptData(emp.extra_efforts) || "",
                            time_efficiency_rank: decryptData(emp.time_efficiency_rank) || "0",
                            overall_standing_rank: decryptData(emp.overall_standing_rank) || "0",
                            "involvement_level_id": emp?.involvement_level_id || "0"
                        });
                        employeeMap[emp.user_code].is_overall = emp?.is_overall
                        employeeMap[emp.user_code].involvement = _.find(options?.involvementLevels, { involvement_level_name: emp.involvement_level_name }) || {};
                        employeeMap[emp.user_code].is_submit = emp.is_submit || false
                        employeeMap[emp.user_code].is_save = emp?.is_save
                        employeeMap[emp?.user_code].project_count = emp?.project_count
                        employeeMap[emp?.user_code].employeeId = emp?.employee_id
                        employeeMap[emp?.user_code].tech = emp?.primary_skill_1
                        employeeMap[emp?.user_code].project = emp?.primary_project
                        employeeMap[emp?.user_code].primaryProject_id = emp?.primary_project_id
                        employeeMap[emp?.user_code].remark = emp?.remark ? decryptData(emp.remark) : ""
                    }
                });
                Object.values(employeeMap).forEach(emp => {
                    let projectEntries = emp?.projectsWiseRank?.filter(
                        proj => proj?.project_id !== 0
                    );
                    projectEntries.sort((a, b) => {
                        const aIsPrimary = a.project_id === emp.primaryProject_id ? 1 : 0;
                        const bIsPrimary = b.project_id === emp.primaryProject_id ? 1 : 0;
                        if (aIsPrimary !== bIsPrimary) {
                            return bIsPrimary - aIsPrimary;
                        }
                    });

                    const overallEntries = emp?.projectsWiseRank?.filter(
                        proj => proj?.project_id === 0
                    );
                    const overallEntry = [{
                        "project_id": 0,
                        "projectName": "Overall",
                        "bu_rank": "0",
                        "db_eff_rank": "",
                        "extra_efforts": "",
                        "tech_rank": "0",
                        "time_efficiency_rank": "0",
                        "overall_standing_rank": "0",
                        "involvement_level_id": "0"
                    }]
                    if (projectEntries.length === 0 && overallEntries?.length === 0) {
                        emp.projectsWiseRank = overallEntry
                        emp.is_overall = true;
                    } else if (projectEntries.length === 1 || overallEntries?.length === 1) {
                        emp.projectsWiseRank = projectEntries.length === 1 ? projectEntries : overallEntries;
                        emp.is_overall = projectEntries.length === 1 ? false : true
                    } else if (projectEntries.length > 1) {
                        emp.projectsWiseRank = [...overallEntry, ...projectEntries]
                        emp.is_overall = false
                    }
                });

                res?.body?.data?.timesheet_data?.forEach(effort => {
                    const userCode = effort.user_code;
                    if (employeeMap[userCode]) {
                        const categoryName = effort?.issue_type_group_name;

                        if (!employeeMap[userCode].category[categoryName]) {
                            employeeMap[userCode].category[categoryName] = [];
                        }
                        employeeMap[userCode].category[categoryName].push(effort);
                    }
                });

                setOptions((prev) => ({ ...prev, isAPICall: false }))
                const sortedData = Object.values(employeeMap).sort((a, b) => {
                    const diff = (a?.is_submit ? 2 : a?.is_save ? 1 : 0) - (b?.is_submit ? 2 : b?.is_save ? 1 : 0);
                    if (diff !== 0) return diff;
                    return a?.name?.localeCompare(b.name);
                });
                setEmployeeDetails(sortedData);
                setExpanded({});
            }
            else {
                setEmployeeDetails([]);
                setExpanded({});
            }
            setFilterValue((prev) => ({ ...prev, apiCall: false }))
            setLoader(false)
        } catch (error) {
            setLoader(false)
            setFilterValue((prev) => ({ ...prev, apiCall: false }))
            console.error("error", error);
        }
    }

    const generateRankTrendOptions = (dataArr, rank) => {
        const uniqueMonths = [...new Set(dataArr.map(d => d.month))];
        const monthCategories = uniqueMonths.map(d => getMonthName(d));
        const seriesMap = new Map();
        const projectNames = new Map();
        dataArr.forEach((value) => {
            if (!seriesMap.has(value?.project_id)) {
                seriesMap.set(value?.project_id, Array(uniqueMonths.length).fill(null));
                projectNames.set(value?.project_id, value?.projectName || `Overall`);
            }
            const monthIndex = uniqueMonths.indexOf(value?.month);
            seriesMap.get(value?.project_id)[monthIndex] = parseInt(value[rank]) || 0;
        });

        const series = [];
        let maxRank = 1;
        seriesMap.forEach((data, project_id) => {
            series.push({
                name: projectNames.get(project_id),
                data,
            });
            const seriesMax = Math.max(...data.filter(val => val > 0));
            maxRank = Math.max(maxRank, seriesMax);
        });

        return {
            title: { text: 'Project-wise Rating Trend', style: { fontWeight: 'bold', fontSize: '14px' } },
            xAxis: {
                categories: monthCategories || [],
                labels: { enabled: true }
            },
            yAxis: {
                title: { text: null },
                labels: { enabled: true },
                // reversed: true,
                min: 1,
                max: maxRank,
                startOnTick: true,
                endOnTick: true
            },
            series,
            chart: {
                type: "spline",
            },
            legend: { enabled: true },
            credits: { enabled: false },
            plotOptions: {
                series: {
                    marker: {
                        enabled: true,
                        radius: 4,
                        states: {
                            hover: {
                                radius: 6
                            }
                        }
                    },
                    lineWidth: 2.5,
                    pointPadding: 0,
                    groupPadding: 0
                }
            },
            tooltip: {
                shared: true,
                useHTML: true,
                formatter: function () {
                    let tooltip = `<b>${this.x}</b><br/>`;
                    this.points.forEach(point => {
                        tooltip += `<span style="color:${point.series.color}">\u25CF</span> ${point.series.name}: Rating <b>${point.y || 'No Rating'}</b><br/>`;
                    });
                    return tooltip;
                }
            }
        };
    };

    const generateCategoryTrendOptions = (dataArr) => {
        return {
            title: { text: "" },
            xAxis: {
                categories: dataArr?.map(d => `${getMonthName(d?.report_month)}`),
                labels: { enabled: false }
            },
            yAxis: {
                title: { text: null },
                min: 0,
                labels: { enabled: false }
            },
            series: [
                {
                    name: 'Percentage',
                    data: dataArr?.map(d => d?.logged_hours_percentage),
                    color: '#0b84e6'
                }
            ],
            tooltip: {
                pointFormatter: function () {
                    return `${this.y.toFixed(2)}%`;
                }
            },
            chart: { type: "spline", height: 50, spacing: [5, 5, 5, 5] },
            legend: { enabled: false },
            credits: { enabled: false },
            plotOptions: { series: { marker: { enabled: true }, lineWidth: 2 } }
        }
    }

    const handleClear = (empId) => {
        setEmployeeDetails(prev =>
            prev.map(emp => {
                if (emp.id === empId) {
                    const clearedProjectsWiseRank = emp.projectsWiseRank.map(project => ({
                        ...project,
                        bu_rank: "0",
                        db_eff_rank: "0",
                        extra_efforts: "0",
                        tech_rank: "0",
                        time_efficiency_rank: "0",
                        overall_standing_rank: "0",
                        involvement_level_id: ""
                    }));
                    const clearedSwot = Object.fromEntries(
                        Object.keys(emp.swot).map(key => [key, ''])
                    );
                    return {
                        ...emp,
                        involvement: '',
                        projectsWiseRank: clearedProjectsWiseRank,
                        swot: clearedSwot
                    };
                }
                return emp;
            })
        );
    };

    const handleSaveDetails = async (empId) => {
        const emp = employeeDetails.find(e => e.id === empId);
        if (!emp) {
            showInfo("Info", "Employee not found");
            return;
        }
        const projects = emp?.is_overall ? _.filter(emp?.projectsWiseRank, item => item.project_id === 0) : _.filter(emp?.projectsWiseRank, item => item.project_id !== 0)
        const isValidNumber = (val) => val !== '' && !isNaN(Number(val)) && Number(val) > 0;
        const projectFullyValid = projects.filter(proj =>
            isValidNumber(proj.bu_rank) &&
            isValidNumber(proj.tech_rank) &&
            isValidNumber(proj.time_efficiency_rank) &&
            isValidNumber(proj.overall_standing_rank) &&
            isValidNumber(proj.involvement_level_id)
        );

        if (projectFullyValid.length !== projects.length) {
            showInfo("Info", `Please fill valid non-negative numbers for all rank fields in all project for employee ${emp.name}.`);
            return;
        }

        let isSwotValid = true;
        for (const [key, value] of Object.entries(emp.swot || {})) {
            if (!value || value.trim() === '' || value.split(/\s+/).filter(Boolean).length < 5) {
                isSwotValid = false;
                break;
            }
        }
        const isRemarkValid = emp?.remark && emp.remark.trim() !== '' && calculateWordsFromString(emp.remark) >= 5;
        if (!isSwotValid && !isRemarkValid) {
            showInfo("Info", `Please provide either a complete SWOT (min 5 words per field) or a Remark (min 5 words) for employee ${emp.name}.`);
            return;
        }
        try {
            const selected_date = getFullMonthSelected(filterValue?.date);
            const payload = {
                month: selected_date?.from_date.getMonth() + 1,
                year: selected_date?.from_date.getFullYear(),
                Requested_user_code: emp.id || 0,
                tvp_precision_pulse_metrics: projects?.map(({ projectName, ...rest }) => ({
                    ...rest,
                    bu_rank: encryptData(rest.bu_rank?.toString() || ""),
                    tech_rank: encryptData(rest.tech_rank?.toString() || ""),
                    db_eff_rank: encryptData(rest.db_eff_rank?.toString() || ""),
                    extra_efforts: encryptData(rest.extra_efforts?.toString() || ""),
                    time_efficiency_rank: encryptData(rest.time_efficiency_rank?.toString() || ""),
                    overall_standing_rank: encryptData(rest.overall_standing_rank?.toString() || ""),
                })) || [],
                opportunity: encryptData(emp?.swot?.opportunity || ""),
                strength: encryptData(emp?.swot?.strength || ""),
                threat: encryptData(emp?.swot?.threat || ""),
                weakness: encryptData(emp?.swot?.weakness || ""),
                is_overall: emp?.is_overall,
                is_save: true,
                remark: encryptData(emp?.remark || "")
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTEAMOVERVIEWPRECISIONPULSEMETRICS"), payload);
            if (!res?.body?.error_status) {
                setEmployeeDetails(prev =>
                    prev.map(emp =>
                        emp.id === empId ? { ...emp, is_save: true } : emp
                    ));
                showSuccess("Success", res.body.message);
            } else {
                showError("Error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("upsert error", error);
        }

        return true;
    };

    const handleChange = (item, field, value, isAPI) => {
        setEmployeeDetails(prev =>
            prev.map(emp => {
                if (emp.id === item?.id) {
                    if (field === "is_overall") {
                        setConfirmationPopup({ show: false })
                        isAPI && handleDelete(item?.id, item?.is_overall)
                        return {
                            ...emp,
                            is_overall: value
                        };
                    } if (field === "remark") {
                        return {
                            ...emp,
                            remark: value
                        };
                    } else {
                        return {
                            ...emp,
                            swot: { ...emp.swot, [field]: value }
                        };
                    }
                }
                return emp;
            })
        );
    };


    const handleDelete = async (id, is_overall) => {
        try {
            const payload = {
                "requested_user_code": id,
                "is_overall": is_overall
            }
            const res = await services.getInvokeRemote("POST", Urls("TEAMOVERVIEWPRECISIONPULSEMETRICSREMOVE"), payload)
            if (!res?.body?.error_status) {
                setEmployeeDetails(prev =>
                    prev.map(emp => {
                        if (emp.id === id) {
                            const data = [{
                                project_id: 0,
                                projectName: "Overall",
                                bu_rank: 0,
                                db_eff_rank: 0,
                                extra_efforts: 0,
                                tech_rank: 0,
                                time_efficiency_rank: 0,
                                overall_standing_rank: 0,
                                involvement_level_id: 0
                            }];
                            const newData = res?.body?.data?.precision_details.map(emp => ({
                                project_id: emp.project_id || 0,
                                projectName: emp.project_name || "Overall",
                                bu_rank: emp.bu_rank?.toString() || "0",
                                "db_eff_rank": emp.db_eff_rank?.toString() || "0",
                                "extra_efforts": emp.extra_efforts?.toString() || "0",
                                "tech_rank": emp.tech_rank?.toString() || "0",
                                "time_efficiency_rank": emp.time_efficiency_rank?.toString() || "0",
                                "overall_standing_rank": emp.overall_standing_rank?.toString() || "0",
                                "involvement_level_id": emp.involvement_level_id || "0"
                            }));
                            return {
                                ...emp,
                                is_submit: false,
                                is_save: false,
                                projectsWiseRank: [...data, ...newData]
                            };
                        }
                        return emp;
                    })
                );
                showSuccess("Success", res.body.message);
            } else {
                showError("Error", res.body.errorMessage)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleSubmit = async () => {
        try {
            const savedEmp = employeeDetails.filter(emp => emp.is_save);
            if (savedEmp?.length > 0) {
                const selected_date = getFullMonthSelected(filterValue?.date);
                const payload = {
                    "from_date": selected_date?.from_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                    "to_date": selected_date?.to_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                    "is_submit": true,
                    "approver_user_code": userCode,
                    "users": _.uniq(_.pluck(savedEmp, "id")).toString()
                }
                const res = await services?.getInvokeRemote("POST", Urls("TEAMOVERVIEWPRECISIONPULSEMETRICSSUBMIT"), payload)
                if (!res?.body?.success) {
                    showSuccess("success", res?.body?.message)
                    getPrecisionDetails();
                    setConfirmation(false)
                } else {
                    showError("Error", res.body.errorMessage);
                }
            } else {
                showInfo("warn", "Please fill at least one employee report");
            }

        } catch (error) {
            console.error(error)
        }
    };

    const groupAndSumByMonth = (dataArray) => {
        const resultMap = {};
        dataArray.forEach(({ report_month, timeSpentSeconds, logged_hours_percentage }) => {
            if (!resultMap[report_month]) {
                resultMap[report_month] = {
                    report_month,
                    logged_hours: 0,
                    logged_hours_percentage: 0,
                };
            }
            resultMap[report_month].logged_hours += parseFloat((timeSpentSeconds / 3600).toFixed(2));
            resultMap[report_month].logged_hours_percentage += parseFloat(logged_hours_percentage);
        });
        return Object.values(resultMap).sort((a, b) => a.report_month - b.report_month);
    };

    const handleMonthChange = (val) => {
        let month = parseInt(filterValue?.date?.getMonth()) + val;
        let year = parseInt(filterValue?.date?.getFullYear());
        if (month < 0) {
            month = 11;
            year -= 1;
        } else if (month > 11) {
            month = 0
            year += 1;
        }
        const newDate = new Date(year, month, 1);
        setFilterValue((prev) => ({ ...prev, date: newDate }));
        getPrecisionDetails(newDate);
    }

    const renderInputNumber = (rowData, field, emp) => {
        const prevRankObj = emp?.prevProjectsWiseRank?.find(p => p.project_id === rowData.project_id);
        const overall = emp?.prevProjectsWiseRank?.filter(p => p.project_id === 0);

        const buildTitle = (data) => {
            if (!data?.length) return 'No prev rank';
            const projectRanks = data?.map(p => {
                const projectName = p.projectName;
                return `${projectName}: ${p[field] || 'N/A'}`;
            })
                ?.slice(0, 5)
                ?.join('\n');

            const titleLines = [];
            if (projectRanks) titleLines.push(projectRanks);
            return titleLines.length ? titleLines.join('\n') : 'No prev rank';
        };
        let title
        if (emp?.is_overall && emp.prevProjectsWiseRank?.length > 1) {
            title = buildTitle(emp.prevProjectsWiseRank)
        } else if (!emp?.is_overall && _.isEmpty(overall) && emp.prevProjectsWiseRank?.length > 1) {
            title = `${prevRankObj?.projectName}: ${prevRankObj?.[field] || 'N/A'}`
        } else {
            title = buildTitle(overall)
        }

        return (
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <input
                    key={rowData?.project_id + field}
                    type="number"
                    value={rowData[field]}
                    onChange={e => {
                        let cleaned = e.target.value.replace(/[^0-9]/g, '');
                        if (cleaned === '0' || cleaned.startsWith('0')) {
                            showInfo("warn", "Value cannot be 0 or start with 0");
                            return;
                        }
                        if (cleaned !== '' && parseInt(cleaned, 10) > 10) {
                            showInfo("warn", "Value cannot be greater than 10");
                            return;
                        }
                        cleaned = cleaned.startsWith("0") ? "" : cleaned;
                        updateProjectCell(emp.id, rowData.project_id, field, cleaned);
                    }}
                    style={{ width: '5rem' }}
                    title={title}
                    min={0}
                    max={10}
                />
            </div>
        );
    };

    const renderDropdown = (rowData, emp) => {
        const prevRankObj = emp?.prevProjectsWiseRank?.find(p => p.project_id === rowData.project_id) || {};
        const value = _.find(options?.involvementLevels, { involvement_level_id: parseInt(prevRankObj?.involvement_level_id) })
        const overall = emp?.prevProjectsWiseRank?.filter(p => p.project_id === 0) || {};

        const buildTitle = (data) => {
            if (!data?.length) return 'No prev rank';
            const projectRanks = data?.map(p => {
                const value = _.find(options?.involvementLevels, { involvement_level_id: parseInt(p?.involvement_level_id) })
                return `Prev: ${value?.involvement_level_name || 'N/A'}`;
            })
                ?.slice(0, 5)
                ?.join('\n');

            const titleLines = [];
            if (projectRanks) titleLines.push(projectRanks);
            return titleLines.length ? titleLines.join('\n') : 'No prev rank';
        };
        let title
        if (emp?.is_overall && emp.prevProjectsWiseRank?.length > 1) {
            title = buildTitle(emp.prevProjectsWiseRank)
        } else if (!emp?.is_overall && _.isEmpty(overall) && emp.prevProjectsWiseRank?.length > 1) {
            title = `${prevRankObj?.projectName}: ${value?.involvement_level_name || 'N/A'}`
        } else {
            title = buildTitle(overall)
        }
        return (
            <select
                key={rowData?.project_id + "_dropdown"}
                value={rowData?.involvement_level_id}
                onChange={(e) => {
                    updateProjectCell(emp.id, rowData.project_id, 'involvement_level_id', e.target.value);
                }}
                style={{ width: '10rem' }}
                title={title}
            >
                <option value="">Select</option>
                {options?.involvementLevels.map(opt => (
                    <option key={opt.involvement_level_id} value={opt.involvement_level_id}>{opt.involvement_level_name}</option>
                ))}
            </select>
        );
    };

    const updateProjectCell = (user_code, project_id, field, value) => {
        setEmployeeDetails(prevData =>
            prevData.map(employee => {
                if (employee.id === user_code) {
                    const updatedProjects = employee.projectsWiseRank.map(project => {
                        if (project.project_id === project_id) {
                            return {
                                ...project,
                                [field]: value,
                            };
                        }
                        return project;
                    });
                    return { ...employee, projectsWiseRank: updatedProjects };
                }
                return employee;
            })
        );
    };

    const handleChartFilter = (e, empId) => {
        setExpanded(prev => ({
            ...prev,
            [empId]: {
                ...prev[empId],
                chart: e.value
            }
        }));
    };

    return useMemo(() => ({
        expanded, setExpanded, filterValue, setFilterValue, options, employeeDetails, generateRankTrendOptions, generateCategoryTrendOptions, handleClear, handleSaveDetails, handleChange, handleSubmit, getPrecisionDetails, loader, groupAndSumByMonth, confirmation, setConfirmation, showInfo, handleMonthChange, renderDropdown, renderInputNumber, confirmationPopup, setConfirmationPopup, handleChartFilter
    }), [expanded, setExpanded, filterValue, setFilterValue, options, employeeDetails, generateRankTrendOptions, generateCategoryTrendOptions, handleClear, handleSaveDetails, handleChange, handleSubmit, getPrecisionDetails, loader, groupAndSumByMonth, confirmation, setConfirmation, showInfo, handleMonthChange, renderDropdown, renderInputNumber, confirmationPopup, setConfirmationPopup, handleChartFilter])
}